import "../CSS/App.css";
import { BrowserRouter, Route } from "react-router-dom";
import CSIMain from "./Main";
import Login from "../auth/Login";
import PrivateRoute from "../auth/PrivateRoute";

function App() {
  return (
    <BrowserRouter forceRefresh={true}>
      <PrivateRoute exact path="/" component={CSIMain} />
      <Route exact path="/login" component={Login} />
    </BrowserRouter>
  );
}

export default App;
